/**
 * eslint-disable @angular-eslint/component-max-inline-declarations
 *
 * @format
 */

/** @format */

import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
const TRANSITION_TIME = 325;
@Component({
	selector: 'common-accordion',
	templateUrl: './accordion.component.html',
	styleUrl: './accordion.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		trigger('openClose', [
			state(
				'open',
				style({
					height: '*',
					opacity: 1
				})
			),
			state(
				'closed',
				style({
					height: '0',
					opacity: 0,
					display: 'none'
				})
			),
			transition('open => closed', [
				animate(`${TRANSITION_TIME}ms cubic-bezier(0.4, 0, 0.2, 1)`)
			]),
			transition('closed => open', [
				animate(`${TRANSITION_TIME}ms cubic-bezier(0.4, 0, 0.2, 1)`)
			])
		])
	],
	standalone: false
})
export class AccordionComponent implements OnInit {
	@Input()
	isArrowIconCentered = false;

	@Input()
	arrowIconSmall: boolean;

	@Input()
	isDisabled: boolean;

	@Input()
	isCollapsed = false;

	@Input()
	isTitleCentered = true;

	@Input()
	hideHeaderLine: boolean;

	@Input()
	hideMobileHeaderLine = false;

	@Input()
	hideArrowIcon: boolean;

	@Input()
	hideHeading = false;

	@Output()
	accordionClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Output()
	isCollapsedChange = new EventEmitter<boolean>();

	public hideBodyAndFooter = false;

	public altText = 'Expand this panel.';

	ngOnInit() {
		if (this.isCollapsed) {
			this.hideBodyAndFooter = true;
		}
	}

	/**
	 * @description
	 * Event handler for when the accordion title is clicked and handles the expand / collapse of the body / footer
	 */
	public expandCollapse($event) {
		if (this.isDisabled) {
			$event.preventDefault();
		} else if (!this.isCollapsed) {
			this.altText = 'Expand this panel.';
			this.isCollapsed = !this.isCollapsed;
			this.isCollapsedChange.emit(this.isCollapsed);
			setTimeout(() => {
				this.hideBodyAndFooter = true;
			}, TRANSITION_TIME);
		} else {
			this.altText = 'Collapse this panel.';
			this.isCollapsed = !this.isCollapsed;
			this.isCollapsedChange.emit(this.isCollapsed);
			this.hideBodyAndFooter = false;
		}

		this.accordionClicked.emit(this.isCollapsed);
	}
}
